import { useInstancesByQuery } from 'hive-react-utils';
export function useFitbitSubs(patientID, collectionType) {
    return useInstancesByQuery('ecarepd', 'fitbitSubByIdCollectionType', 'fitbitSub', {}, patientID, collectionType);
}
